import { dayjs } from '@/plugins/dayjs';
import moment from 'moment';

const CustomFilter = {
  msm_date(value) {
    if (!value) return '';
    return moment(value).format('L');
  },
  msm_datetime(value) {
    if (!value) return '';
    return moment(value).format('L LT');
  },
  msm_datetime_long(value) {
    if (!value) return '';
    return moment(value).format('LLL');
  },
  msm_time(value) {
    if (!value) return '';
    return moment(value).format('LT');
  },
  msm_year(value) {
    if (!value) return '';
    return moment(value).format('YYYY');
  },
  msm_yearmonth(value) {
    if (!value) return '';
    return moment(value).format('YYYY-MM');
  },
  msm_timefromnow(value) {
    if (!value) return '';
    return moment(value).fromNow();
  },
  toOneDecimal(value) {
    if (!value && value !== 0) return '';
    return parseFloat(value).toFixed(1);
  },
  tooltipDate(value) {
    if (!value) return '';
    return new Date(value).toLocaleString('default', {month: 'short', year: 'numeric'});
  }
};

export default CustomFilter;
